'use client';

import Image from 'next/image';
import { FC } from 'react';
export interface AiPersonalizedProps {
  title: React.ReactNode;
  description: React.ReactNode;
  features: {
    icon: React.ReactNode,
    title: string;
    description: string;
  }[]
  subTitle: React.ReactNode;
}

const AiPersonalized: FC<AiPersonalizedProps> = ({
  title,
  description,
  features = [],
  subTitle,

}) => {
  return (
    <div className="bg-violet-900 text-white px-[16px] md:px-[64px] pb-[48px]">
      <div className="flex">
        <div className="pt-0 md:pt-[64px] mx-auto max-w-[1384px]">
          <div className="text-left border-[1px] border-solid border-violet-800">
            <div className="flex justify-center flex-wrap pt-[64px] pb-[60px] bg-center bg-no-repeat bg-[url('https://front.com/webassets/rebrand/header-blur.svg')] relative px-[16px] md:px-0">
              <div className="absolute top-[-17px] left-[-17px] hidden md:block">
                <Image src="https://front.com/webassets/rebrand/ai-plus.svg" width={35} height={35} alt="ai plus" />
              </div>
              <h2 className="text-white text-p2 md:text-display3 font-500 text-center mb-[16px] w-full">{title}</h2>
              <div className="flex w-full justify-center text-center text-violoet-300 text-p1">
                {description}
              </div>
            </div>
            <div className="flex justify-between flex-wrap md:flex-nowrap border-t-[1px] border-solid border-violet-800">
              {features.map((item, index) => {
                return (
                  <div key={`feature-card-${index}`} className="flex flex-wrap w-full mr-0 md:mr-[16px] md:mb-0 items-start justify-center border-r-0 border-b-[1px] md:border-b-0 md:border-r-[1px] last:border-none border-solid border-violet-800 pt-[32px] md:pt-[55px] pr-[40px] pl-[40px] pb-[32px] md:pb-[65px]">
                    <div className="flex flex-wrap justify-center items-start">
                      <div className="flex min-h-[55px]">
                        <div className="flex bg-violet-1000 rounded-[16px] h-[36px]">
                          <div className="flex" id="icon">
                            <span className="flex w-[32px] h-[32px] bg-citron-500 rounded-[50%] justify-center items-center mr-[16px] mt-[2px] mb-[2px] ml-[2px]">
                              {item.icon}
                            </span>
                          </div>
                          <div className="flex text-p1 text-white font-500 mr-[16px]" id="textHeader">
                            {item.title}
                          </div>
                        </div>
                      </div>
                      <div className="flex text-p2 text-violet-300 text-center">
                        {item.description}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="flex justify-between my-[120px] flex-wrap md:flex-nowrap">
            <div className="flex flex-wrap items-start max-w-[100%] md:max-w-[318px] w-full bg-violet-800 rounded-[12px] mr-0 md:mr-[16px] mb-[16px] md:mb-0">
              <div className="flex w-full justify-center mt-[40px] mb-[60px]">
                <Image src="https://front.com/webassets/rebrand/dealdash.png" width={114} height={29} alt="DealDash logo" className="mix-blend-luminosity" />
              </div>
              <div className="flex w-full justify-center">
                <span className="text-white text-89/97">2x</span>
              </div>
              <div className="flex text-violet-300 text-p1 w-full justify-center mt-[24px] mb-[55px]">
                response time decrease
              </div>
            </div>

            <div className="flex flex-wrap items-start max-w-[100%] md:max-w-[318px] w-full bg-violet-800 rounded-[12px] mr-0 md:mr-[16px] mb-[16px] md:mb-0">
              <div className="flex w-full justify-center mt-[40px] mb-[60px]">
                <Image src="https://front.com/webassets/rebrand/mixam-logo.png" width={115} height={29} alt="DealDash logo" className="mix-blend-luminosity" />
              </div>
              <div className="flex w-full justify-center">
                <span className="text-white text-89/97">61%</span>
              </div>
              <div className="flex text-violet-300 text-p1 w-full justify-center mt-[24px] mb-[55px]">
                increase in resolution rate
              </div>
            </div>

            <div className="flex flex-wrap items-start max-w-[100%] md:max-w-[318px] w-full bg-violet-800 rounded-[12px] mr-0 md:mr-[16px] mb-[16px] md:mb-0">
              <div className="flex w-full justify-center mt-[40px] mb-[60px]">
                <Image src="https://front.com/webassets/rebrand/essentialist-logo.png" width={150} height={17} alt="Essentialist logo" />
              </div>
              <div className="flex w-full justify-center">
                <span className="text-white text-89/97">97%</span>
              </div>
              <div className="flex text-violet-300 text-p1 w-full justify-center mt-[24px] mb-[55px]">
                CSAT score
              </div>
            </div>

            <div className="flex flex-wrap items-start max-w-[100%] md:max-w-[318px] w-full bg-violet-800 rounded-[12px] mb-[16px] md:mb-0">
              <div className="flex w-full justify-center mt-[40px] mb-[60px]">
                <Image src="https://front.com/webassets/rebrand/structured-logo.png" width={156} height={34} alt="Structured logo" />
              </div>
              <div className="flex w-full justify-center">
                <span className="text-white text-89/97">10%</span>
              </div>
              <div className="flex text-violet-300 text-p1 w-full justify-center mt-[24px] mb-[55px]">
                workload reduction
              </div>
            </div>
          </div>
          <div className="grid gap-2 md:gap-3 text-left">
            <div className="flex justify-center flex-wrap">
              <h2 className="text-white text-center text-h2 md:text-display2 font-500 md:text-center mb-[16px]">{subTitle}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiPersonalized;
